import { useState } from "react";
import UserManagementMain from "components/UserManagement/UserManagementMain";
import MainLayout from 'layouts/mainLayout'

export default function UserManagementPage() {
    const [formOpen, setFormOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openInviteSentForm, setOpenInviteSentForm] = useState(false);
    const [showNotification, setShowNotification] = useState({ type: "", message: "" });

    const companyName = "ACME";
    const users = [
        {
            "userId": "1",
            "epPortalUserId": 1,
            "firstName": "Olivia",
            "lastName": "Emma",
            "email": "olivia.emma@example.com",
            "userRoleId": 2,
            "userRole": "Administrator",
            "externalId": null,
            "status": "Invited",
            "invitedDate": "2025-02-27T09:28:42.841443Z",
            "isSMSEnabled": false,
            "isEmailEnabled": false,
            "smsOptInDate": null,
            "emailOptInDate": null,
            "jobTitle": null,
            "phoneNumber": null
        },
        {
            "userId": "2",
            "epPortalUserId": 2,
            "firstName": "Charlotte",
            "lastName": "Oliver",
            "email": "charlotte.oliver@example.com",
            "userRoleId": 3,
            "userRole": "Editor",
            "externalId": null,
            "status": "Active",
            "invitedDate": "2025-02-20T06:16:27.278350Z",
            "isSMSEnabled": false,
            "isEmailEnabled": false,
            "smsOptInDate": null,
            "emailOptInDate": null,
            "jobTitle": null,
            "phoneNumber": null
        },
        {
            "userId": "3",
            "epPortalUserId": 3,
            "firstName": "Amelia",
            "lastName": "James",
            "email": "amelia.james@example.com",
            "userRoleId": 4,
            "userRole": "Reader",
            "externalId": null,
            "status": "Active",
            "invitedDate": "2025-01-08T06:26:09.337438Z",
            "isSMSEnabled": false,
            "isEmailEnabled": false,
            "smsOptInDate": null,
            "emailOptInDate": null,
            "jobTitle": null,
            "phoneNumber": null
        },
        {
            "userId": "4",
            "epPortalUserId": 4,
            "firstName": "Isabella",
            "lastName": "Oliver",
            "email": "isabella.oliver@example.com",
            "userRoleId": 2,
            "userRole": "Administrator",
            "externalId": null,
            "status": "Active",
            "invitedDate": "2024-06-03T10:00:42.995104Z",
            "isSMSEnabled": false,
            "isEmailEnabled": false,
            "smsOptInDate": null,
            "emailOptInDate": null,
            "jobTitle": null,
            "phoneNumber": null
        },
        {
            "userId": "5",
            "epPortalUserId": 5,
            "firstName": "Mateo",
            "lastName": "Lucas",
            "email": "mateo.lucas@example.com",
            "userRoleId": 2,
            "userRole": "Administrator",
            "externalId": null,
            "status": "Active",
            "invitedDate": "2024-04-16T10:00:25.387608Z",
            "isSMSEnabled": false,
            "isEmailEnabled": false,
            "smsOptInDate": null,
            "emailOptInDate": null,
            "jobTitle": "",
            "phoneNumber": ""
        },]
    const roles = [
        {
            "userRoleId": 2,
            "userRoleName": "Administrator",
            "userAccessControl": "ADMINISTRATOR"
        },
        {
            "userRoleId": 3,
            "userRoleName": "Editor",
            "userAccessControl": "EDITOR"
        },
        {
            "userRoleId": 4,
            "userRoleName": "Reader",
            "userAccessControl": "READER"
        }
    ]

    const selectedPartner = {
        "id": 1,
        "name": "ACME Technologies Limited",
        "description": "ACME Technologies Limited",
        "logoURI": null
    }


    async function handleSubmit(data) {
        setFormOpen(false);

    }

    function handleEditUser(user) {
        setSelectedUser(user);
        setFormOpen(true);
    }

    function handleInviteUser(user) {
        setSelectedUser(null);
        setFormOpen(true);
    }

    function handleFormClose() {
        setFormOpen(false);
    }

    function handelInviteSentFormClose() {
        setOpenInviteSentForm(false);
    }
    function handleAlertClose() {
        setShowNotification({ type: "", message: "" });
    }

    return (
        <MainLayout>
            <UserManagementMain
                loading={false}
                isPartnerChanged={false}
                users={users}
                roles={roles}
                companyName={companyName}
                selectedPartner={selectedPartner}
                selectedUser={selectedUser}
                formOpen={formOpen}
                isAdmin={true}
                openInviteSentForm={openInviteSentForm}
                showNotification={showNotification}
                onInviteSentFormClose={handelInviteSentFormClose}
                onAlertClose={handleAlertClose}
                onSubmit={handleSubmit}
                onDelete={() => { }}
                onResend={() => { }}
                onInviteUser={handleInviteUser}
                onEditUser={handleEditUser}
                onFormClose={handleFormClose}
            />
        </MainLayout>
    );
}
